import React, { FunctionComponent } from "react";
import { Badge, IconProps } from "@chakra-ui/react";
import { WarningTwoIcon, InfoIcon, QuestionOutlineIcon } from '@chakra-ui/icons'
import { useIntl } from "react-intl";

interface IProps extends IconProps {
  alarmType: string;
  onlyActive: boolean;
}

const NotificationIcon: FunctionComponent<IProps> = ({
  alarmType,
  onlyActive,
  ...rest
}) => {
  const intl = useIntl();
  const iconColor = (color: string) => ({
    color: color,
    opacity: onlyActive ? 1 : .5,
  });
  const alarmLabel = (alarmType: string) => {
    switch(alarmType.toUpperCase()) {
      case "ERROR":
      case "T:ERROR": return intl.formatMessage({
        id: "notifications__alarm_type__error",
        defaultMessage: "ERROR",
      });
      case "WARNING":
      case "T:WARNING": return intl.formatMessage({
        id: "notifications__alarm_type__warning",
        defaultMessage: "WARNING",
      });
      case "INFO":
      case "T:INFO": return intl.formatMessage({
        id: "notifications__alarm_type__info",
        defaultMessage: "INFO",
      });
    }
  }

  const renderIcon = () => {
    switch (alarmType.toUpperCase()) {
      case "ERROR":
      case 'T:ERROR':
        return (<WarningTwoIcon {...iconColor('red.500')} />);
      case "WARNING":
      case 'T:WARNING':
        return (<WarningTwoIcon {...iconColor('yellow.500')} />);
      case "INFO":
      case 'T:INFO':
        return (<InfoIcon {...iconColor('')} />);
      default:
        return (<QuestionOutlineIcon {...iconColor('')} />);
    }
  }

  return (
    <div>
      {renderIcon()}
      <Badge variant='subtle'>{alarmLabel(alarmType)}</Badge>
    </div>
  );
  
};

export default NotificationIcon;
